import { Inject, Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { UiStore, UiState } from './ui.store';
import { distinctUntilChanged, map, shareReplay, tap } from 'rxjs/operators';
import { fromEvent } from 'rxjs';
import { DOCUMENT } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class UiQuery extends Query<UiState> {
    landingPage$ = this.select('landingPage');
    landingPage = () => (this.getValue().landingPage ? this.getValue().landingPage : '');
    currentTour? = () => this.getValue().currentTour;
    scrollYPositionObservable$ = this.select('scrollTopObservable').pipe(
        distinctUntilChanged(),
        shareReplay(1)
    );
    get viewportSize() {
        return this.getValue().viewportSize;
    }
    viewportSize$ = this.select('viewportSize');
    isVisible$ = fromEvent(this._document, 'visibilitychange').pipe(
        map((_) => !this._document.hidden),
        distinctUntilChanged(),
        shareReplay(0)
    );
    constructor(
        protected store: UiStore,
        @Inject(DOCUMENT) private _document: HTMLDocument
    ) {
        super(store);
    }

    get startPage() {
        return this.getValue().url || this.landingPage();
    }

    get isMobile() {
        return this.getValue().isMobile;
    }
}
